module.exports = __webpack_public_path__ + "img/pin.376f8703.png";